import type { TupleToUnion } from 'type-fest'

import type { Action } from './actions.ts'
import type { Resource } from './resource.ts'

export const Permissions = [
  'activity:create',
  'activity:view',

  'agency:edit',
  'agency:view',
  'brand:view',

  'file:upload',

  'bid:create',
  'bid:administer',

  'cost:view',
  'cost-plus-margin:view',

  'project:view',
  'project:accept',
  'project:archive',
  'project:comment',
  'project:create',
  'project:duplicate',
  'project:delete',
  'project:edit',
  'project:submit',
  'project:complete',
  'project:administer',

  'customer-organization:administer',
  'own-organization:administer',

  'customer-team:administer',
  'own-organization-team:administer',
  'own-team:administer',
  'own-team-profile:update',

  'customer-user:administer',
  'own-organization-user:administer',
  'own-team-user:administer',

  'package:view',
  'package:administer',

  'match:edit',
  'match:remove',
  'match:view',

  'review:administer',
  'review-feedback:update',
  'review-proposal:update',

  'internal-pricing-note:view',
] as const satisfies readonly `${Resource}:${Action}`[]

export type Permission = TupleToUnion<typeof Permissions>

export const AllPermissions = [...Permissions]
